<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('dharma.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="books_route">{{ $t('dharma.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-nav pills fill>
          <b-nav-item-dropdown :text="$t('dharma.list.application.title')">
            <b-dropdown-item
              :to="applicable_books_route"
            >{{ $t('dharma.list.book.title') }}</b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'dharmas', params: { group: 'applicable', type: 'picture' } }"
            >{{ $t('dharma.list.picture.title') }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown :text="$t('dharma.list.download.title')">
            <b-dropdown-item
              :to="downloadable_books_route"
            >{{ $t('dharma.list.book.title') }}</b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'dharmas', params: { group: 'downloadable', type: 'picture' } }"
            >{{ $t('dharma.list.picture.title') }}</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item
            active
            :to="{ name: 'dharmas-search' }"
          >{{ $t('dharma.list.search.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col-12">
          <application-list-button-toolbar></application-list-button-toolbar>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-form @submit="submitKeyword">
            <b-form-group :label="$t('dharma.list.search.type-selector.label')" label-cols-sm="2" label-size="lg">
              <b-form-select
                v-model="type"
                style="border-color: black; color: black"
                size="lg"
              >
                <b-form-select-option value="book">
                  {{ $t('dharma.list.search.type-selector.option.book.label') }}
                </b-form-select-option>
                <b-form-select-option value="picture">
                  {{ $t('dharma.list.search.type-selector.option.picture.label') }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-input-group size="lg">
              <b-form-input
                style="border-color: black; color: black"
                :placeholder="$t('dharma.list.search.keyword-inputor.hint')"
                v-model="keyword"
              ></b-form-input>
              <b-input-group-append>
                <b-button type="submit" variant="primary">{{ $t('dharma.list.search.button.search.label') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </div>
      </div>
      <div class="row mt-3" v-if="search_completed && dharmas.length > 0">
        <div class="col-12">
          <b-form-select v-model="per_page" :options="per_page_options"></b-form-select>
        </div>
      </div>
      <book-card-list
        :books="dharmas"
        v-if="type === 'book' && search_completed && dharmas.length > 0"
      ></book-card-list>
      <picture-card-list
        :pictures="dharmas"
        v-if="type === 'picture' && search_completed && dharmas.length > 0"
      ></picture-card-list>
      <div class="row mt-3" v-if="search_completed && show_next_page_notice">
        <div class="col-12">
          <b-alert show class="text-center font-weight-bold mb-0 border-0" style="font-size: 1.75rem; background-color: #F7F4EF; color: #ff3030;">
            {{ $t('dharma.list.modal.next-page-notice.message') }}
          </b-alert>
        </div>
      </div>
      <div class="row mt-3" v-if="search_completed && dharmas.length > 0">
        <div class="col-12">
          <b-pagination
            size="lg"
            align="center"
            v-model="page"
            :total-rows="dharmas_meta.total"
            :per-page="per_page"
            @change="pageChange"
          ></b-pagination>
        </div>
      </div>
      <div class="row mt-3" v-if="search_completed && dharmas.length === 0">
        <div class="col-12">
          <h5 class="text-danger font-weight-bold">{{ $t('dharma.list.search.message.no-result') }}</h5>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { FormGroupPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import ApplicationListButtonToolbar from '@/components/button-toolbars/application-list-button-toolbar/ApplicationListButtonToolbar'
import BookCardList from '@/components/lists/BookCardList'
import PictureCardList from '@/components/lists/PictureCardList'

import i18n from '@/plugins/i18n.js'

import BookApiService from '@/services/budaedu-api-services/book-api-service.js'
import PictureApiService from '@/services/budaedu-api-services/picture-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(IconsPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)

Vue.use(BookApiService)
Vue.use(PictureApiService)

export default {
  i18n,
  name: 'dharmas-search',
  props: {
    // 
  },
  data() {
    return {
      is_loading: false,
      type: 'book',
      keyword: '',
      search_completed: false,
      page: 1,
      total: 0,
      dharmas: [],
      dharmas_meta: { total: 0, current_page: null, last_page: null },
      dharma: {},
      dharma_image: {},
      dharma_efiles: [],
      dharma_downloadable_efile: null,
      dharma_printable_efile: null
    }
  },
  computed: {
    applicable_books_route() {
      return {
        name: 'dharmas',
        params: { group: 'applicable', type: 'book' },
        query: { language: (this.$i18n.locale === 'tw' ? 'chinese' : 'english') }
      }
    },
    downloadable_books_route() {
      return {
        name: 'dharmas',
        params: { group: 'downloadable', type: 'book' },
        query: { language: (this.$i18n.locale === 'tw' ? 'chinese' : 'english') }
      }
    },
    per_page() {
      return this.type === 'book' ? 30 : 30
    },
    per_page_options() {
      return [
        { value: 30, text: this.$t('paginator.items-per-page-selector.option.label', { size: 30 }) },
        { value: 50, text: this.$t('paginator.items-per-page-selector.option.label', { size: 50 }) },
        { value: 100, text: this.$t('paginator.items-per-page-selector.option.label', { size: 100 }) },
        { value: 200, text: this.$t('paginator.items-per-page-selector.option.label', { size: 200 }) }
      ]
    },
    show_next_page_notice() {
      return this.dharmas_meta.last_page &&
        this.dharmas_meta.current_page &&
        this.dharmas_meta.last_page > this.dharmas_meta.current_page &&
        this.dharmas.filter(dharma => dharma.in_stock == 'Y').length == this.per_page
    },
    /**
     * 將使用者輸入的關鍵字（以空格隔開）解析為陣列
     * 同時支援半形空格、全形空格，並自動 trim 與合併連續空白
     */
    parsedKeywords() {
      return this.keyword.trim().split(/[\s\u3000]+/).filter(k => k.length > 0)
    }
  },
  watch: {
    per_page(new_value, old_value) {
      this.page = 1
      this.setDharmasAndPaging()
    }
  },
  methods: {
    submitKeyword(event) {
      event.preventDefault()
      this.page = 1
      this.setDharmasAndPaging()
    },
    pageChange(page) {
      this.page = page
      this.setDharmasAndPaging()
    },
    async setDharmasAndPaging() {
      this.search_completed = false
      this.is_loading = true
      this.dharmas = []

      try {
        let items = {}
        let preview = { url: 'img/common.jpg' }
        const additional = `filter[have_efile]&order=latest_storage_date,desc|created_at,desc&per_page=${this.per_page}&page=${this.page}`

        if (this.type == 'book') {
          if (this.parsedKeywords.length > 1) {
            // 多關鍵字：以逗號分隔傳入 filter[of_keywords]（AND 邏輯）
            items = await this.$bookApiService.queryByKeywords(
              this.parsedKeywords.join(','),
              additional
            )
          } else if (this.parsedKeywords.length === 1) {
            // 單一關鍵字：維持原有 filter[of_keyword]
            items = await this.$bookApiService.queryByKeyword(
              this.parsedKeywords[0],
              additional
            )
          } else {
            items = await this.$bookApiService.query(additional)
          }

          const previewPromises = items.data.map(async (book) => {
            book.front_cover = await this.$bookApiService.getFrontCover(book, preview)
          })
          await Promise.all(previewPromises)
        } else if (this.type == 'picture') {
          if (this.parsedKeywords.length > 1) {
            // 多關鍵字：以逗號分隔傳入 filter[of_keywords]（AND 邏輯）
            items = await this.$pictureApiService.queryByKeywords(
              this.parsedKeywords.join(','),
              additional
            )
          } else if (this.parsedKeywords.length === 1) {
            // 單一關鍵字：維持原有 filter[of_keyword]
            items = await this.$pictureApiService.queryByKeyword(
              this.parsedKeywords[0],
              additional
            )
          } else {
            items = await this.$pictureApiService.query(additional)
          }

          const previewPromises = items.data.map(async (picture) => {
            picture.preview = await this.$pictureApiService.getPreviewableEfile(picture, preview)
          })
          await Promise.all(previewPromises);
        }
        
        this.dharmas = items.data
        this.dharmas_meta = items.meta
      } finally {
        this.is_loading = false
        this.search_completed = true
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    ApplicationListButtonToolbar,
    BookCardList,
    PictureCardList
  },
  metaInfo() {
    return {
      title: this.$t('dharma.list.search.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>
